import React from "react";
import { Trophy, Play as PlayIcon, Home } from "lucide-react";
import Confetti from "@/components/game/Confetti";
import Stat from "@/components/game/Stat";
import ShareScore from "@/components/game/ShareScore";
import { MINIGAME_REWARD } from "@/data/catalog";

export default function EndOverlay({ result, mode, score, hits, miniDef, streak, onHome, onRetry }) {
  const win = result === "win";
  return (
    <div
      className="absolute inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-30 p-4"
      data-testid="end-overlay"
    >
      {win && <Confetti />}
      <div
        className="neon-card p-6 sm:p-10 text-center max-w-md w-full anim-pop-in"
        style={{ borderColor: win ? "#39FF14" : "#FF3B30" }}
      >
        {win ? (
          <>
            <Trophy className="w-16 h-16 mx-auto neon-yellow anim-glow-pulse" color="#FFD700" />
            <h2
              className="font-display font-black text-4xl sm:text-5xl mt-3 neon-yellow"
              data-testid="win-title"
            >
              VICTORY!
            </h2>
            <p className="font-body text-white/80 mt-2">
              {mode === "classic" ? "Awesome shooting!" : "Mini game cleared!"}
            </p>
          </>
        ) : (
          <>
            <div className="text-6xl" aria-hidden="true">💀</div>
            <h2
              className="font-display font-black text-4xl sm:text-5xl mt-2 neon-pink"
              data-testid="lose-title"
            >
              OUCH!
            </h2>
            <p className="font-body text-white/80 mt-2">
              {mode === "classic" ? "Better luck next time." : "Missed the goal. Try again!"}
            </p>
          </>
        )}
        <div className="mt-5 grid grid-cols-2 gap-3 text-left">
          <Stat label="Coins earned" value={score} color="#FFD700" />
          <Stat label="Hits" value={hits} color="#00FFFF" />
          {mode !== "classic" && mode !== "boss" && miniDef && (
            <Stat label="Goal" value={miniDef.hitGoal} color="#FF007F" />
          )}
          {win && mode !== "classic" && (
            <Stat label="Bonus" value={`+${MINIGAME_REWARD}`} color="#39FF14" />
          )}
        </div>
        {win && (
          <div className="mt-4">
            <ShareScore score={score} hits={hits} mode={mode} streak={streak} />
          </div>
        )}
        <div className="mt-4 flex flex-col sm:flex-row gap-3">
          <button
            className="btn-neon btn-cyan flex-1"
            onClick={onRetry}
            data-testid="retry-btn"
          >
            <PlayIcon className="w-5 h-5" /> Play Again
          </button>
          <button
            className="btn-neon btn-pink flex-1"
            onClick={onHome}
            data-testid="home-btn"
          >
            <Home className="w-5 h-5" /> Home
          </button>
        </div>
      </div>
    </div>
  );
}
